module.exports = __webpack_public_path__ + "img/hikvision.db7e518.gif";